import Enum from '@square/dashboard-utilities/utils/enum';
import Product from '@square/dashboard-data/models/squareup/simple-instrument-store/api/product';
import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
export const Type = new Enum(['CARD', 'BANK']);
export const SortOrder = new Enum(['DO_NOT_USE', 'ACCOUNT_TOKEN_TYPE', 'LINKED_AT_DESCENDING']);
export const EntityTokenType = new Enum(['DO_NOT_USE', 'APPOINTMENT', 'PERSON', 'WEB_MERCHANT', 'MERCHANT_CONTACT', 'LOYALTY_CONTACT']);
export const Entity = ProtoBaseModel.extend({
  tokenType: attr(EntityTokenType),
  token: attr(String)
});
export const LinkContext = ProtoBaseModel.extend({
  linkingEntity: attr(Entity),
  initiatingEntity: attr(Entity)
});
export const OwnershipContext = ProtoBaseModel.extend({
  entity: attr(Entity),
  merchantToken: attr(String)
});
export const ProductContext = ProtoBaseModel.extend({
  product: attr(Product),
  subProduct: attr(String)
});
export const UsageContext = ProtoBaseModel.extend({
  productContext: attr(ProductContext),
  ownershipContext: attr(OwnershipContext)
});
export const QueryInstrumentRequest = ProtoBaseModel.extend({
  owningEntities: repeated(Entity),
  productContexts: repeated(ProductContext),
  type: attr(Type, {
    defaultValue: Type.CARD
  }),
  sortOrder: attr(SortOrder, {
    defaultValue: SortOrder.LINKED_AT_DESCENDING
  })
}).reopenClass({
  url: '/api/v1/instruments/query-instrument'
});